import { getProfileCountry, normalizeProfileCountry } from "../constants/profileLocations";

export const buildEventMapState = (event) => {
  const publicationCountry = event?.publication_country_code;
  const countryValue = publicationCountry || event?.country || "";
  const countryCode = normalizeProfileCountry(countryValue);
  const country = getProfileCountry(countryValue)?.label || countryValue || null;

  return {
    focusEventId: event?.id,
    coords: event?.latitude != null && event?.longitude != null
      ? [Number(event.longitude), Number(event.latitude)]
      : null,
    region: countryCode === "RU" ? "RU" : "SK",
    country,
    city: event?.publication_city || event?.city || null,
    municipalityId: event?.publication_municipality_id || null,
  };
};
